import React from 'react';

export const ProgramClassificationsCard = ({
    cipCode,
    cipTitle,
    stemPff,
    nextLevelJobs,
    careerRelevance,
    endYear,
    programKeywords,
}) => (
    <div className="card p-3 mb-3 h-100">
        <h5 className="text-strong mb-3">Program Classifications</h5>
        <div className="row mb-3">
            <div className="col-md">
                <label className="d-block text-muted">CIP</label>
                <div>{cipCode}</div>
                <div>{cipTitle}</div>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col-md mb-3 mb-md-0">
                <label className="d-block text-muted">STEM PFF</label>
                <div>{stemPff}</div>
            </div>
            <div className="col-md">
                <label className="d-block text-muted">Next Level Jobs</label>
                <div>{nextLevelJobs}</div>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col-md mb-3 mb-md-0">
                <label className="d-block text-muted">Career Relevance</label>
                <div>{careerRelevance}</div>
            </div>
            <div className="col-md">
                <label className="d-block text-muted">End Year</label>
                <div>{endYear}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-md">
                <label className="d-block text-muted">Program Keywords</label>
                <div>{programKeywords}</div>
            </div>
        </div>
    </div>
);
